<template>
    <div class="bidding-plan-page">
      <div class="page-header">
        <div class="header-left">
          <i class="el-icon-arrow-left back-btn" @click="goBack"></i>
          <h2 class="page-title">采购计划</h2>
        </div>
      </div>
  
      <div class="form-container">
        <el-card class="form-card">
  
          <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" label-position="right">
            <!-- 采购计划标题 -->
            <el-form-item label="采购计划标题" prop="noticeName">
              <el-input 
                v-model="formData.noticeName" 
                placeholder="请输入采购计划标题"
                maxlength="200"
                show-word-limit
                clearable
              />
            </el-form-item>
  
            <!-- 地区选择 -->
            <el-form-item label="地区" prop="region">
              <el-cascader
                ref="regionCascader"
                v-model="formData.region"
                placeholder="请选择省市区"
                :props="regionCascaderProps"
                @change="handleRegionChange"
                clearable
                class="region-cascader"
              />
            </el-form-item>
  
  
            <!-- 发布时间 -->
            <el-form-item label="发布时间">
              <el-date-picker
                v-model="formData.createBy"
                type="datetime"
                placeholder="选择发布时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="datetime-picker"
              />
            </el-form-item>
  
            <!-- 采购计划内容 -->
            <el-form-item label="采购计划内容" prop="noticecontent">
              <div class="editor-wrapper">
                <rich-text-editor
                  v-model="formData.noticecontent"
                  placeholder="请输入采购计划内容..."
                  :height="400"
                />
              </div>
            </el-form-item>
          </el-form>
        </el-card>
  
        <!-- 底部操作栏 -->
        <div class="bottom-actions">
          <el-button size="medium" @click="goBack">取消</el-button>
          <el-button type="primary" size="medium" @click="handleSubmit" :loading="submitLoading">
            <i class="el-icon-check"></i> 保存
          </el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { savePurchaseScheme } from '@/api/modules/agent'
  import RegionUtils from '@/utils/regionUtils'
  import RichTextEditor from '@/components/common/RichTextEditor.vue'
  
  export default {
    name: 'BiddingPlan',
    components: {
      RichTextEditor
    },
    data() {
      return {
        formData: {
          noticeName: '',          // 采购计划标题
          noticecontent: '',       // 采购计划内容（富文本）
          createBy: '',            // 发布时间
          // 地区相关字段
          region: [],              // 地区选择数组
          provincecode: '',        // 省编码
          provinceName: '',        // 省名称
          citycode: '',           // 市编码
          cityName: '',           // 市名称
          countycode: '',         // 区编码
          countyName: ''          // 区名称
        },
        formRules: {
          noticeName: [
            { required: true, message: '请输入采购计划标题', trigger: 'blur' },
            { min: 2, max: 200, message: '标题长度在 2 到 200 个字符', trigger: 'blur' }
          ],
          region: [
            { required: true, message: '请选择地区', trigger: 'change' }
          ],
          noticecontent: [
            { required: true, message: '请输入采购计划内容', trigger: 'blur' }
          ]
        },
        submitLoading: false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7 // 可选择今天及之后的日期
          }
        }
      }
    },
    computed: {
      // 地区级联选择器配置
      regionCascaderProps() {
        return RegionUtils.getCascaderProps()
      },
      channelCode() {
        return this.$channelMaterial.getChannelCode()
      },
    },
    mounted() {
      // 初始化当前时间为发布时间默认值
      this.initDateTime()
      // 初始化地区字段
      RegionUtils.initRegionFields(this.formData)
    },
    methods: {
      // 初始化当前时间
      initDateTime() {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0')
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')
        this.formData.createBy = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      },
  
      /**
       * 地区选择变化处理
       */
      async handleRegionChange(value) {
        await RegionUtils.handleRegionChange(
          value,
          this.$refs.regionCascader,
          this.formData,
          { enableDebug: false },
          this,
          'REGION_CODE'
        )
      },
  
      /**
       * 提交表单
       */
      handleSubmit() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) {
            this.$message.warning('请完善表单信息')
            return false
          }
  
          // 提交前兜底：确保地区字段已从级联中完整回填
          if (Array.isArray(this.formData.region) && this.formData.region.length > 0) {
            const regionCheckedNodes = this.$refs.regionCascader?.getCheckedNodes?.() || []
            const regionPathNodes = regionCheckedNodes[0]?.pathNodes || []
            
            if (regionPathNodes[0]) {
              this.formData.provincecode = regionPathNodes[0].value || ''
              this.formData.provinceName = regionPathNodes[0].label || ''
            }
            if (regionPathNodes[1]) {
              this.formData.citycode = regionPathNodes[1].value || ''
              this.formData.cityName = regionPathNodes[1].label || ''
            }
            if (regionPathNodes[2]) {
              this.formData.countycode = regionPathNodes[2].value || ''
              this.formData.countyName = regionPathNodes[2].label || ''
            }
          }
  
          this.submitLoading = true
          try {
            const submitData = {
              channelCode: this.channelCode,
              noticeName: this.formData.noticeName,
              noticeContent: this.formData.noticecontent, 
              noticeSendTime: this.formData.createBy,
              provinceCode: this.formData.provincecode,
              provinceName: this.formData.provinceName,
              cityCode: this.formData.citycode,
              cityName: this.formData.cityName,
              countyCode: this.formData.countycode,
              countyName: this.formData.countyName
            }
  
            const res = await savePurchaseScheme(submitData)
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$router.go(-1)
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          } catch (error) {
            this.$message.error('保存失败，请重试')
            console.error('保存失败:', error)
          } finally {
            this.submitLoading = false
          }
        })
      },
  
      /**
       * 返回上一页
       */
      goBack() {
        this.$router.go(-1)
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .bidding-plan-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%);
    padding: 20px;
  }
  
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  
    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  
    .back-btn {
      font-size: 20px;
      color: #606266;
      cursor: pointer;
      padding: 8px;
      border-radius: 8px;
      transition: all 0.3s;
  
      &:hover {
        background: #f5f7fa;
        color: #409eff;
      }
    }
  
    .page-title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #303133;
    }
  
    .header-actions {
      display: flex;
      gap: 12px;
    }
  }
  
  .form-container {
    //max-width: 900px;
    margin: 0 auto;
  }
  
  .form-card {
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  
    .card-header {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  
    .card-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }
  
  .region-cascader {
    width: 100%;
    max-width: 400px;
  }
  
  .region-display {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  
    .el-tag {
      border-radius: 8px;
      padding: 0 12px;
    }
  
    .placeholder-text {
      color: #909399;
      font-size: 14px;
    }
  }
  
  .datetime-picker {
    width: 100%;
    max-width: 300px;
  }
  
  .editor-wrapper {
    border-radius: 8px;
    overflow: hidden;
    transition: border-color 0.3s;
  
    &:hover,
    :focus-within {
      border-color: #409eff;
    }
  }
  
  .bottom-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  
    .el-button {
      min-width: 120px;
      border-radius: 10px;
    }
  }
  
  /deep/ .el-form-item {
    margin-bottom: 24px;
  
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  
    .el-input__inner {
      border-radius: 10px;
      height: 40px;
      line-height: 40px;
      border-color: #dcdfe6;
      transition: all 0.3s;
  
      &:focus {
        border-color: #409eff;
      }
  
      &:hover {
        border-color: #c0c4cc;
      }
    }
  
    .el-input__count {
      background: transparent;
    }
  }
  
  /deep/ .el-form-item__error {
    font-size: 12px;
    padding-top: 4px;
  }
  
  /deep/ .el-card__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
    border-bottom: none;
    padding: 16px 20px;
  
    .card-title {
      color: #fff;
    }
  }
  
  /deep/ .el-card__body {
    padding: 28px 32px;
  }
  </style>
  